<template>
    <div>
        
    </div>
</template>

<script>
import Vue from 'vue'
import http from '@/libs/http'

export default {
    name: 'homepage',
    data() {
        return { 
        }
    },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/homepage.vue